import React, { useEffect, useReducer, useState, useRef } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useLocation, useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp'
// eslint-disable-next-line import/no-webpack-loader-syntax
import RoomIcon from '@material-ui/icons/Room'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import {
    KeyboardDatePicker,
    KeyboardDateTimePicker,
    KeyboardTimePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

import { get, post, put, del } from '../../config/fetch'
import AlertWrapper from '../common/alert'
import { Chip } from '@material-ui/core'
import Avatar from '@material-ui/core/Avatar'
import {
    TOKEN_CREATE_NOTIFICATION,
    TOKEN_DELETE_NOTIFICATION,
    TOKEN_GET_DEVICES_LIST,
    TOKEN_NOTIFICATION_BY_DATE, TOKEN_UPDATE_NOTIFICATION,
} from '../../constants/constants'

const useStyles = makeStyles(theme => ({
    map: {
        position: 'relative',
        width: '98%',
        margin: '1em auto',
        padding: '1em',
        height: 'calc(100% - 2em)',
        overflowY: 'auto',
        [theme.breakpoints.down('md')]: {
            height: '300px',
        },
    },
    circularProgress: {
        width: '100%',
        overflowY: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '550px',
        [theme.breakpoints.down('md')]: {
            height: '300px',
        },
    },
    emailContent: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
    },
    chip: {
        margin: theme.spacing(0.5),
    },
}))

const defaultCenter = {
    lng: -80.287839,
    lat: 25.963922,
}

const notificationElement = () => {
    let el = document.createElement('div')
    el.className = 'marker-notification'
    el.style.backgroundImage =
        'url(https://iconsplace.com/wp-content/uploads/_icons/ffffff/256/png/radio-tower-icon-18-256.png)'
    el.style.width = '40px'
    el.style.height = '40px'
    el.style.backgroundSize = '100%'
    el.style.opacity = '0.7'
    return el
}

const fieldTypes = {
    'roaming': {
        'type': 'bool',        
    },
    'volte': {
        'type': 'bool',
    },
    'mobiledata': {
        'type': 'bool',
    },
    'battery': {
        'type': 'bool',
    },
    'rssi': {
        'type': 'numeric',
    },
    'rsrq': {
        'type': 'numeric',
    },
    'rsrp': {
        'type': 'numeric',
    },
    'date': {
        'type': 'datetime',
    },
}


function DialogDelete(props) {
    const { classes, handleCloseDialogDelete, state, handleDeleteNotification, visible } = props

    return (
        <Dialog
            open={visible}
            onClose={handleCloseDialogDelete}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Delete Base Station</DialogTitle>
            <DialogContent>
                <DialogContentText>Are you sure to delete this base station?</DialogContentText>
                {state.loading && (
                    <div className={classes.wrapperLoader}>
                        <CircularProgress />
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialogDelete} color="primary" disabled={state.loading}>
                    Cancel
                </Button>
                <Button
                    onClick={() => handleDeleteNotification(state.id)}
                    color="primary"
                    type="submit"
                    disabled={state.loading}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    )
}

function NotificationsDetail(props) {
    const { action } = props
    const { handleSubmit, control, setValue, getValues } = useForm()
    const classes = useStyles()
    const location = useLocation()
    const history = useHistory()
    const mapContainer = useRef()
    const [map, setMap] = useState(null)
    const [state, setState] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: true,
        resolved: false,
        notification: {
            conditions: [],
            name: '',
            deviceListId: '',
            startDate: '',
            endDate: '',
            emailList: []
        },
        message: null,
        typeMessage: null,
        visibleMessage: false,
    })
    const [stateDialogDelete, setStateDialogDelete] = useReducer((s, a) => ({ ...s, ...a }), {
        loading: false,
        visible: false,
        id: null,
    })
    const [devicesList, setDevicesList] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: true,
        resolved: false,
        devicesList: []
    })
    const notificationId = location.pathname.split('/')[2]
    const [conditionFields, setConditionFields] = useState([])
    const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    //const [devicesList, setDevicesList] = useState([]);
    const [selectedDate, handleDateChange] = useState(new Date());
    const [selectedDateEnd, handleDateEndChange] = useState(new Date());

    const [emailList, setEmailList] = useState([]);

    useEffect(() => {
        state.notification.startDate = new Date();
        state.notification.endDate = new Date();
        
        fetchDevicesList().then()
            .then(response => {
                setDevicesList({
                    ...devicesList,
                    loading: false,
                    resolved: true,
                    devicesList: response,
                })
            })
            .catch(e => {
                setDevicesList({
                    ...devicesList,
                    loading: false,
                    error: e,
                })
            });

        if (action === 'create') {
            setState({
                ...state,
                loading: false,
                resolved: true,
            })                        
        } else if (action === 'update') {
            const id = location.pathname.split('/')[2]
            
            fetchNotification(id).then(notification => {
                setState({
                    ...state,
                    loading: false,
                    resolved: true,
                    notification: notification,
                })
                
                setSelectedStartDate(new Date (notification.startDate));
                setSelectedEndDate(new Date(notification.endDate));
                setEmailList(notification.emailList)
                
                let items = [];
                notification.conditions.forEach((value, index) => {
                    let fieldType = fieldTypes[value.field]['type'];
                    let element = createElement(fieldType, index, value.value1);
                    items.push(element);
                });
                setConditionFields(items);
            })
        }
        
    }, [])

    const addCondition = () => {
        setState({
            ...state,            
            notification: {
                'conditions': [
                    ...state.notification.conditions,
                    {field:"", value1: "", value2:""}
                ],
                'name': state.notification.name,
                'startDate': state.notification.startDate,
                'endDate': state.notification.endDate
            }
        });        
    }

    const fetchNotification = async id => {
        try {
            const { data: notification } = await get(
                `/notificationsList/${id}?code=${TOKEN_NOTIFICATION_BY_DATE}`,
            )

            return notification
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchDevicesList = async () => {
        try {
            const { data: devicesList } = await get(
                `/devicesList?code=${TOKEN_GET_DEVICES_LIST}`,
            )

            return devicesList
        } catch (e) {
            throw new Error(e)
        }
    }

    const handleForm = async data => {
        state.notification.conditions.forEach((value, index) => {
            const value1 = data['value1-' + index];
            const value2 = data['value2-' + index];

            state.notification.conditions[index].value1 = value1;
            state.notification.conditions[index].value2 = value2;
        });
        
        state.notification.name = data.name;
        state.notification.deviceListId = data.deviceListId;
        state.notification.emailList = emailList;
        
        setState({
            ...state,
            loading: true,
            resolved: false,
        })

        if (action === 'create') {
            const responseCreate = await createNotification(data)
            if (responseCreate.success) {
                setState({
                    loading: false,
                    resolved: true,
                    visibleMessage: true,
                    typeMessage: 'success',
                    message: `Notification has been saved successfuly.`,
                })
            } else {
                setState({
                    loading: false,
                    resolved: true,
                    error: responseCreate.errors[0].msg,
                    visibleMessage: true,
                    typeMessage: 'error',
                    message: responseCreate.errors[0].msg,
                })
            }
        } else if (action === 'update') {
            const id = location.pathname.split('/')[2]
            const responseUpdate = await updateNotification(id, data)
            if (responseUpdate.success) {
                setState({
                    loading: false,
                    resolved: true,
                    visibleMessage: true,
                    typeMessage: 'success',
                    message: `Notification has been updated successfuly.`,
                })
            } else {
                setState({
                    loading: false,
                    resolved: true,
                    error: responseUpdate.errors[0].msg,
                    visibleMessage: true,
                    typeMessage: 'error',
                    message: responseUpdate.errors[0].msg,
                })
            }
        }
    }

    const handleStartDate = evt => {
        //state.selectedStartDate = evt;
        state.notification.startDate = new Date(evt);
        
        setSelectedStartDate(evt);
        
        /*setState({
            ...state, selectedStartDate: evt
        });*/
        
        /*
        setState({
            ...state,
            notification: {
                'conditions': state.notification.conditions,
                'name': state.notification.name,
                'startDate': evt
            }
        });
        */

    }

    const handleEndDate = evt => {
        state.notification.endDate = new Date(evt);
        setSelectedEndDate(evt);

    }


    const handleFieldChange = evt => {
        //console.log('Entre en handleFieldChange: ', evt);
        //console.log('Entre en handleFieldChange: ', evt.target.name);
        //state.notification.name = evt.target.value;
        
        /*
        if (['field', 'value1', 'value2'].includes(evt.target.name)) {
            console.log('Entre: ');
            
            //let index = evt.target.id.replace("field-","");
            let conditionsDB = state.notification.conditions;
            //conditionsDB[index][evt.target.name] = evt.target.value;
            let name = evt.target.value;

            console.log(conditionsDB);
            console.log('name: ', name);

            setState({
                ...state,            
                notification: {
                    'conditions': conditionsDB,
                    'name': name
                }
            });
        }
        */
    }

    const handleChangeConditionField = (evt, item) => {
        let index = evt.target.name.replace("field-","");

        // console.log(evt.target.getAttribute('id'));
        //let index = evt.target.id.replace("field-","");
        //let index = evt.target.name;
        //let index = conditionFields.length;
        let fieldType = "";
        let fieldName = evt.target.value;
        if (fieldName) {
            fieldType = fieldTypes[fieldName]['type'];
        }
        
        console.log(fieldType);
        console.log(evt.target.value);

        state.notification.conditions[index].field = fieldName;

        let elements = (<p>Select field</p>);
        switch(fieldType) {
            case 'bool':
                elements = (                    
                    <Grid item xs={12} md={9}>   
                        <Grid
                            container
                            direction="row"
                            style={{ padding: '1em 0' }}
                            justify="space-between"
                            alignItems="center"
                            spacing={4}
                        >
                            <Grid item xs={6} md={6}>
                                <h2>Is:</h2>
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <Controller
                                    control={control}
                                    defaultValue='true'
                                    name={ `value1-${index}` }
                                    rules={{ required: true }}
                                    render={({ field, fieldState }) => (
                                        <Select
                                            {...field}
                                            labelId={ `value1-label-${index}` }
                                            id={ `value1-${index}` }
                                            fullWidth
                                            required
                                            inputRef={field.ref}                                    
                                            error={fieldState.invalid}
                                        >
                                            <MenuItem value="">
                                                <em>Select value</em>
                                            </MenuItem>
                                            <MenuItem value="true">True</MenuItem>
                                            <MenuItem value="false">False</MenuItem>                                    
                                        </Select>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                )
                break;
            case 'numeric':
                elements = (
                    <Grid item xs={12} md={9}>   
                        <Grid
                            container
                            direction="row"
                            style={{ padding: '1em 0' }}
                            justify="space-between"
                            alignItems="center"
                            spacing={4}
                        >
                            <Grid item xs={6} md={6}>
                                <InputLabel id={ `value1-label-${index}` }>
                                    Between *
                                </InputLabel>
                                <Controller
                                    control={control}
                                    defaultValue=''
                                    name={ `value1-${index}` }
                                    rules={{ required: true }}
                                    render={({ field, fieldState }) => (
                                        <TextField
                                            {...field}
                                            margin="dense"
                                            label=""
                                            type="number"
                                            fullWidth
                                            inputRef={field.ref}
                                            error={fieldState.invalid}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <InputLabel id={ `value2-label-${index}` }>
                                    And *
                                </InputLabel>
                                <Controller
                                    control={control}
                                    defaultValue=''
                                    name={ `value2-${index}` }
                                    rules={{ required: true }}
                                    render={({ field, fieldState }) => (
                                        <TextField
                                            {...field}
                                            margin="dense"
                                            label=""
                                            type="number"
                                            fullWidth
                                            inputRef={field.ref}
                                            error={fieldState.invalid}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid> 
                )
                break;
            case 'datetime':
                elements = (
                    <Grid item xs={12} md={9}>   
                        <Grid
                            container
                            direction="row"
                            style={{ padding: '1em 0' }}
                            justify="space-between"
                            alignItems="center"
                            spacing={4}
                        >
                            <Grid item xs={6} md={6}>
                                <InputLabel id={ `value1-label-${index}` }>
                                    From *
                                </InputLabel>
                                
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
{/*
                                    <KeyboardDatePicker
                                        id={ `value1-${index}` }
                                        label="Select filter date"
                                        format="MM/dd/yyyy"
                                        value=""
                                        onChange={handleStartDate}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
*/}
                                    <KeyboardDatePicker
                                        id={ `value1-${index}` }
                                        clearable
                                        value={selectedStartDate}
                                        placeholder="10/10/2018"
                                        //onChange={date => handleStartDateChange(date)}
                                        minDate={new Date()}
                                        format="MM/dd/yyyy"
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <InputLabel id={ `value2-label-${index}` }>
                                    To *
                                </InputLabel>
                                
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker
                                        id={ `value2-${index}` }
                                        label="Select filter date"
                                        format="MM/dd/yyyy"
                                        value=""             
                                        onChange={handleStartDate}                           
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                        </Grid>
                    </Grid>                    
                )
                break;
        }

        
        let items = [...conditionFields];        
        items[index] = elements;        
        setConditionFields(items);
        console.log('notification.conditions: ', state.notification.conditions);
    }
    
    const createElement = (fieldType, index, defaultValue1) => {
        let elements = (<p>Select field</p>);
        
        switch(fieldType) {
            case 'bool':
                elements = (
                    <Grid item xs={12} md={9}>
                        <Grid
                            container
                            direction="row"
                            style={{ padding: '1em 0' }}
                            justify="space-between"
                            alignItems="center"
                            spacing={4}
                        >
                            <Grid item xs={6} md={6}>
                                <h2>Is:</h2>
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <Controller
                                    control={control}
                                    defaultValue={defaultValue1}
                                    name={ `value1-${index}` }
                                    rules={{ required: true }}
                                    render={({ field, fieldState }) => (
                                        <Select
                                            {...field}
                                            labelId={ `value1-label-${index}` }
                                            id={ `value1-${index}` }
                                            fullWidth
                                            required
                                            inputRef={field.ref}
                                            error={fieldState.invalid}
                                        >
                                            <MenuItem value="">
                                                <em>Select value</em>
                                            </MenuItem>
                                            <MenuItem value="true">True</MenuItem>
                                            <MenuItem value="false">False</MenuItem>
                                        </Select>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                )
                break;
            case 'numeric':
                elements = (
                    <Grid item xs={12} md={9}>
                        <Grid
                            container
                            direction="row"
                            style={{ padding: '1em 0' }}
                            justify="space-between"
                            alignItems="center"
                            spacing={4}
                        >
                            <Grid item xs={6} md={6}>
                                <InputLabel id={ `value1-label-${index}` }>
                                    Between *
                                </InputLabel>
                                <Controller
                                    control={control}
                                    defaultValue=''
                                    name={ `value1-${index}` }
                                    rules={{ required: true }}
                                    render={({ field, fieldState }) => (
                                        <TextField
                                            {...field}
                                            margin="dense"
                                            label=""
                                            type="number"
                                            fullWidth
                                            inputRef={field.ref}
                                            error={fieldState.invalid}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <InputLabel id={ `value2-label-${index}` }>
                                    And *
                                </InputLabel>
                                <Controller
                                    control={control}
                                    defaultValue=''
                                    name={ `value2-${index}` }
                                    rules={{ required: true }}
                                    render={({ field, fieldState }) => (
                                        <TextField
                                            {...field}
                                            margin="dense"
                                            label=""
                                            type="number"
                                            fullWidth
                                            inputRef={field.ref}
                                            error={fieldState.invalid}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                )
                break;
            case 'datetime':
                elements = (
                    <Grid item xs={12} md={9}>
                        <Grid
                            container
                            direction="row"
                            style={{ padding: '1em 0' }}
                            justify="space-between"
                            alignItems="center"
                            spacing={4}
                        >
                            <Grid item xs={6} md={6}>
                                <InputLabel id={ `value1-label-${index}` }>
                                    From *
                                </InputLabel>

                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    {/*
                                    <KeyboardDatePicker
                                        id={ `value1-${index}` }
                                        label="Select filter date"
                                        format="MM/dd/yyyy"
                                        value=""
                                        onChange={handleStartDate}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
*/}
                                    <KeyboardDatePicker
                                        id={ `value1-${index}` }
                                        clearable
                                        value={selectedStartDate}
                                        placeholder="10/10/2018"
                                        //onChange={date => handleStartDateChange(date)}
                                        minDate={new Date()}
                                        format="MM/dd/yyyy"
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <InputLabel id={ `value2-label-${index}` }>
                                    To *
                                </InputLabel>

                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker
                                        id={ `value2-${index}` }
                                        label="Select filter date"
                                        format="MM/dd/yyyy"
                                        value=""
                                        onChange={handleStartDate}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                        </Grid>
                    </Grid>
                )
                break;
        }
        return elements;
    }

    const handleClickDelete = id => {
        setStateDialogDelete({
            ...stateDialogDelete,
            visible: true,
            id,
        })
    }

    const handleCloseDialogDelete = () => {
        setStateDialogDelete({
            ...stateDialogDelete,
            visible: false,
            id: null,
        })
    }

    const handleDeleteNotification = async id => {
        setStateDialogDelete({
            ...stateDialogDelete,
            loading: true,
        })
        deleteNotification(id)
            .then(response => {
                setStateDialogDelete({
                    ...stateDialogDelete,
                    loading: false,
                    visible: false,
                })
                setState({
                    ...state,
                    visibleMessage: true,
                    typeMessage: 'success',
                    message: `Base station has been deleted successfully.`,
                })
                setTimeout(() => {
                    history.goBack()
                }, 1500)
            })
            .catch(error => {
                setStateDialogDelete({
                    ...stateDialogDelete,
                    loading: false,
                })
            })
    }

    const createNotification = async data => {
        try {
            const dataResponse = await post(
                `/notifications?code=${TOKEN_CREATE_NOTIFICATION}`,
                state.notification,
            )
            return dataResponse
        } catch (e) {
            throw new Error(e)
        }
    }

    const deleteNotification = async id => {
        try {
            const { data: notification } = await del(
                `/notifications/${id}?code=${TOKEN_DELETE_NOTIFICATION}`,
            )

            return notification
        } catch (e) {
            throw new Error(e)
        }
    }

    const updateNotification = async (id, data) => {
        try {
            const dataResponse = await put(
                `/notifications/${id}?code=${TOKEN_UPDATE_NOTIFICATION}`,
                state.notification,
            )

            return dataResponse
        } catch (e) {
            throw new Error(e)
        }
    }

    const handleEmailKeyDown = event => {
        //console.log('Entre: ', event);
        if (event.key === "Enter") {
            console.log('Entre en enter: ');
            const email = event.target.value.trim()
            console.log('Entre en enter: ', email);

            const newSelectedItem = [...emailList];
            let k = (Math.random() + 1).toString(36).substring(5);
            //{ key: 0, label: 'Angular' },
            console.log('Key: ', k);

            newSelectedItem.push({ key: k, email: email });
            setEmailList(newSelectedItem);
            event.target.value = "";
        }
    }

    const handleDeleteEmail = (emailToDelete) => () => {
        console.log('Entre a borrar')
        setEmailList((chips) => chips.filter((chip) => chip.key !== emailToDelete.key));
    };

    const handleCloseMessageReport = () => {
        setState({
            ...state,
            visibleMessage: false,
        })
    }

    const flyToLocation = () => {
        const values = getValues(['latitude', 'longitude'])
        map.flyTo({
            center: [Number(values[1]), Number(values[0])],
        })
    }

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            flyToLocation()
        }
    }

    const cidOrEnb = value => {
        const values = getValues(['cid', 'eNB'])
        return Boolean(!!values[0] + !!values[1])
    }

    return (
        <Grid container spacing={0}>
            <Grid container direction="row" justify="center" alignItems="center">
                <Grid item xs={11} direction="column" style={{ borderBottom: '1px solid' }}>
                    <h2>Notification</h2>
                </Grid>
            </Grid>
            <Grid container direction="row" justify="space-evenly" alignItems="stretch">
                <Grid xs={11} lg={7} item>
                    <Paper
                        elevation={3}
                        style={{
                            width: '100%',
                            margin: '1em 0',
                            padding: '1em',
                            height: 'auto',
                            overflowY: 'auto',
                        }}
                    >
                        <Grid
                            xl={12}
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                            style={{ borderBottom: '1px solid #111' }}
                        >
                            <h3>Information</h3>
                        </Grid>
                        {state.resolved ? (
                            <form onSubmit={handleSubmit(handleForm)} onChange={handleFieldChange}>
                                <Grid
                                    container
                                    direction="row"
                                    style={{ padding: '1em 0' }}
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={4}
                                >
                                    <Grid item xs={6} md={6} lg={6}>
                                        <Controller
                                            defaultValue={state.notification.name}
                                            control={control}
                                            name="name"
                                            rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    autoFocus
                                                    margin="dense"
                                                    label="Name"
                                                    type="text"
                                                    fullWidth
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    
                                    <Grid item xs={6} md={6} lg={6}>
                                        <InputLabel id="device-list-label">
                                            Device list *
                                        </InputLabel>
                                        <Controller
                                            defaultValue={state.notification.deviceListId || ''}
                                            control={control}
                                            name="deviceListId"
                                            rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <Select
                                                    {...field}
                                                    labelId="device-list-label"
                                                    id="device-list"
                                                    fullWidth
                                                    //required
                                                    inputRef={field.ref}
                                                    //value={condition.field}
                                                    //onChange={handleChangeConditionField}
                                                    error={fieldState.invalid}
                                                >
                                                    <MenuItem value="">
                                                        <em>Select one</em>
                                                    </MenuItem>
                                                    {devicesList.devicesList.map(value => {
                                                        return (
                                                            <MenuItem value={value.id}>{value.name}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={6} md={6} lg={6}>
                                        <Controller
                                            defaultValue={state.notification.startDate}
                                            //defaultValue={new Date()}
                                            control={control}
                                            name="startDate"
                                            //rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardDatePicker
                                                        {...field}
                                                        label="From"
                                                        clearable
                                                        value={selectedStartDate}
                                                        //placeholder="10/10/2018"
                                                        onChange={date => handleStartDate(date)}
                                                        //minDate={new Date()}
                                                        inputRef={field.ref}
                                                        format="dd/MM/yyyy"
                                                        //error={fieldState.invalid}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={6} lg={6}>
                                        <Controller
                                            defaultValue={state.notification.endDate}
                                            //defaultValue={new Date()}
                                            control={control}
                                            name="endDate"
                                            //rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardDatePicker
                                                        {...field}
                                                        label="To"
                                                        clearable
                                                        value={selectedEndDate}
                                                        //placeholder="10/10/2018"
                                                        onChange={date => handleEndDate(date)}
                                                        //minDate={new Date()}
                                                        inputRef={field.ref}
                                                        format="dd/MM/yyyy"
                                                        //error={fieldState.invalid}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={6} md={6} lg={6}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                label="Start time"
                                                placeholder="08:00 AM"
                                                mask="__:__ _M"
                                                value={selectedDate}
                                                onChange={date => handleDateChange(date)}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={6} md={6} lg={6}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                label="End time"
                                                placeholder="08:00 AM"
                                                mask="__:__ _M"
                                                value={selectedDateEnd}
                                                onChange={date => handleDateEndChange(date)}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    
                                </Grid>
                                <Grid
                                    xl={12}
                                    container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="center"
                                    style={{ borderBottom: '1px solid #111' }}
                                >
                                    <Grid item xs={9} md={9}>
                                        <h2>Conditions:</h2>
                                    </Grid>
                                    <Grid item xs={3} md={3}>
                                        <Button size="small" color="primary" onClick={addCondition}>
                                            Add condition
                                        </Button>
                                     </Grid>
                                </Grid>
                                {state.notification.conditions.map((condition, i) => (
                                    <Grid
                                        container
                                        direction="row"
                                        style={{ padding: '1em 0' }}
                                        justify="space-between"
                                        alignItems="center"
                                        spacing={4}
                                    >                                    
                                        <Grid item xs={12} md={3}>
                                            <InputLabel id={ `field-label-${i}` }>
                                                Field *
                                            </InputLabel>
                                            <Controller
                                                control={control}
                                                defaultValue={condition.field}
                                                name={ `field-${i}` }
                                                //rules={{ required: true }}
                                                render={({ field, fieldState }) => (
                                                    <Select
                                                        {...field}
                                                        labelId={ `field-label-${i}` }
                                                        id={ `field-${i}` }
                                                        fullWidth
                                                        //required
                                                        inputRef={field.ref}
                                                        value={condition.field}
                                                        onChange={handleChangeConditionField}
                                                        error={fieldState.invalid}
                                                    >
                                                        <MenuItem value="">
                                                            <em>Select field</em>
                                                        </MenuItem>
                                                        <MenuItem value="roaming">Roaming</MenuItem>
                                                        <MenuItem value="volte">VoLTE</MenuItem>
                                                        <MenuItem value="mobiledata">Mobile Data</MenuItem>
                                                        <MenuItem value="battery">Save Battery</MenuItem>
{/*
                                                        <MenuItem value="rssi">RSSI</MenuItem>
                                                        <MenuItem value="rsrq">RSRQ</MenuItem>
                                                        <MenuItem value="rsrp">RSRP</MenuItem>
                                                        <MenuItem value="date">Date</MenuItem>
*/}
                                                    </Select>
                                                )}
                                            />
                                        </Grid>
                                        {conditionFields[i]}
                                    </Grid>
                                ))}
                            </form>
                        ) : (
                            <div className={classes.circularProgress}>
                                <CircularProgress color="inherit" />
                            </div>
                        )}
                    </Paper>
                </Grid>
                
                <Grid xs={11} lg={4} item>
                    <Paper component="ul"
                           elevation={3}
                           style={{
                               width: '100%',
                               margin: '1em 0',
                               padding: '1em',
                               height: 'auto',
                               overflowY: 'auto',
                           }}
                           className={classes.emailContent}
                    >
                        <Grid
                            xl={12}
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                            style={{ borderBottom: '1px solid #111' }}
                        >
                            <h3>Email list</h3>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            style={{ padding: '1em 0' }}
                            justify="space-between"
                            alignItems="center"
                            spacing={4}
                        >
                            <Grid item xs={12} md={12} lg={12}>
                                <TextField id="standard-basic" 
                                           label="Add email" 
                                           fullWidth 
                                           onKeyDown={event => handleEmailKeyDown(event)}
                                />
                                
                            </Grid>
                        </Grid>


                        {emailList.map((data) => {
                            return (
                                <li key={data.key}>
                                    <Chip
                                        avatar={<Avatar>{data.email.charAt(0).toUpperCase()}</Avatar>}
                                        color="primary"
                                        label={data.email}
                                        onDelete={handleDeleteEmail(data)}
                                        className={classes.chip}
                                    />
                                </li>
                            );
                        })}
                    </Paper>
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                style={{ margin: '2em 0' }}
            >
                <Grid xs={11} container direction="row" justify="flex-end" alignItems="center">
{/*
                    {action === 'update' && (
                        <Button
                            type="button"
                            variant="contained"
                            color="default"
                            onClick={() => handleClickDelete(notificationId)}
                        >
                            delete
                        </Button>
                    )}
*/}
                    &nbsp;&nbsp;&nbsp;
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit(handleForm)}
                    >
                        save
                    </Button>
                </Grid>
            </Grid>
            <AlertWrapper
                description={state.message}
                handleClose={handleCloseMessageReport}
                type={state.typeMessage}
                visible={state.visibleMessage}
            />
            <DialogDelete
                classes={classes}
                handleCloseDialogDelete={handleCloseDialogDelete}
                state={stateDialogDelete}
                handleDeleteNotification={handleDeleteNotification}
                visible={stateDialogDelete.visible}
            />
        </Grid>
    )
}

export default NotificationsDetail
